"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commentErrorSchema = exports.commentDeletedSchema = exports.adminCommentListSchema = exports.commentListSchema = exports.commentSchema = exports.commentUserSchema = exports.adminCommentListQuerySchema = exports.commentListQuerySchema = exports.commentIdParamSchema = exports.adminCommentUpdateListSchema = exports.adminCommentUpdateSchema = exports.commentUpdateSchema = exports.adminCommentCreateListSchema = exports.adminCommentCreateSchema = exports.commentCreateSchema = void 0;
const zod_1 = require("zod");
const user_1 = require("./user");
const optionalQueryValue = (value) => value === "" || value === undefined || value === null ? undefined : value;
exports.commentCreateSchema = zod_1.z.object({
    masterId: zod_1.z.number().int().positive(),
    text: zod_1.z.string().trim().min(1, "Comment is required").max(2000),
});
exports.adminCommentCreateSchema = exports.commentCreateSchema
    .extend({
    userId: zod_1.z.number().int().positive().optional(),
    username: zod_1.z.string().trim().min(1).max(80).optional(),
})
    .refine((comment) => comment.userId !== undefined || !!comment.username, {
    message: "userId or username is required",
});
exports.adminCommentCreateListSchema = zod_1.z.object({
    comments: zod_1.z.array(exports.adminCommentCreateSchema).min(1).max(100),
});
exports.commentUpdateSchema = zod_1.z.object({
    text: zod_1.z.string().trim().min(1, "Comment is required").max(2000),
});
exports.adminCommentUpdateSchema = zod_1.z.object({
    id: zod_1.z.number().int().positive(),
    text: zod_1.z.string().trim().min(1, "Comment is required").max(2000),
    userId: zod_1.z.number().int().positive().optional(),
    masterId: zod_1.z.number().int().positive().optional(),
});
exports.adminCommentUpdateListSchema = zod_1.z.object({
    comments: zod_1.z
        .array(exports.adminCommentUpdateSchema)
        .min(1)
        .max(100)
        .refine((items) => new Set(items.map((item) => item.id)).size === items.length, {
        message: "Duplicate comment id",
    }),
});
exports.commentIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
exports.commentListQuerySchema = zod_1.z.object({
    masterId: zod_1.z.coerce.number().int().positive(),
});
exports.adminCommentListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().positive().default(1),
    pageSize: zod_1.z.coerce.number().int().positive().max(100).default(20),
    q: zod_1.z.preprocess(optionalQueryValue, zod_1.z.string().trim().min(1).optional()),
    masterId: zod_1.z.preprocess(optionalQueryValue, zod_1.z.coerce.number().int().positive().optional()),
});
exports.commentUserSchema = user_1.userSchemaBase.pick({
    id: true,
    username: true,
    title: true,
    profilePictureThumbnailUrl: true,
});
exports.commentSchema = zod_1.z.object({
    id: zod_1.z.number().int().positive(),
    text: zod_1.z.string(),
    masterId: zod_1.z.number().int().positive(),
    userId: zod_1.z.number().int().positive(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    user: exports.commentUserSchema,
    master: exports.commentUserSchema,
});
exports.commentListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.commentSchema),
});
exports.adminCommentListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.commentSchema),
    total: zod_1.z.number().int().nonnegative(),
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
});
exports.commentDeletedSchema = zod_1.z.object({
    message: zod_1.z.literal("Comment deleted"),
});
exports.commentErrorSchema = zod_1.z.object({
    message: zod_1.z.string(),
    errors: zod_1.z
        .object({
        formErrors: zod_1.z.array(zod_1.z.string()),
        fieldErrors: zod_1.z.record(zod_1.z.string(), zod_1.z.array(zod_1.z.string())),
    })
        .optional(),
});
